export const NotificationConfig = []

export const NotificationTypeKeyMap = {
  survey: 3,
  hippaConsent: 4,
  hippaAssent: 5
}
